import { lazy } from "react";

export const Profile = lazy(() => import("./Profile"));
export const BrandDetails = lazy(() => import("./BrandDetails"));
export const BrandDetailsV2 = lazy(() => import("./BrandDetailsV2"));
export const BrandDetailsV3 = lazy(() => import("./BrandDetailsV3"));
//
export const Setting = lazy(() => import("./Setting"));

